import React from "react";
import HomeProjectCard from "../Home/Home/HomeProjectCard/HomeProjectCard";
import style from "./HomeProjects.module.css";
import { Container, Row } from "react-bootstrap";
import useAllProjects from "../../hooks/useAllProjects";
import { Link } from "react-router-dom";

const HomeProjects = () => {
  const [projects] = useAllProjects();
  const homeProjects = projects.slice(0, 3);
  // console.log(projects, 'projects');
  return (
    <div className={style.homeProject__container}>
      <Container>
        <Row>
          <div className={style.homeProject__title}>
            <h4>PORTFOLIO</h4>
            <h1>
              MY <span className={style.text__highlight}>BEST</span>{" "}
              <span style={{ color: "#DD1C63" }}>PROJECTS</span>
            </h1>
          </div>
        </Row>
      </Container>
      <div className={style.project__Card}>
        <Row xs={12} sm={12} md={4} lg={4}>
          {homeProjects.map((project) => (
            <HomeProjectCard
              key={project.id}
              project={project}
            ></HomeProjectCard>
          ))}
        </Row>
      </div>
      <div className={style.see__all__button}>
        <Link to="/projects" >
          <button style={{textAlign:'center'}}>See All Projects</button>
        </Link>
      </div>
    </div>
  );
};

export default HomeProjects;
